<template>
  <abstract-autocomplete
    v-model="localValue"
    :list-api="listApi"
    :multiple="multiple"
    :return-object="returnObject"
    :query-param="queryParam"
    :id-predicate-path="idPredicatePath"
    :show-validation="showValidation"
    :vid="vid"
    :rules="rules"
    :chips="chips"
    :clearable="clearable"
    :deletable-chips="deletableChips"
    :small-chips="smallChips"
    :outlined="outlined"
    :rounded="rounded"
    :dense="dense"
    :single-line="singleLine"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :selected-item-to-text="selectedItemToText"
    :item-value="itemValue"
    :preload-all-options="preloadAllOptions"
    :counter="counter"
    :search-debounce-time="searchDebounceTime"
    @change="$emit('change', $event)"
    @inputObject="$emit('inputObject', $event)"
  >
    <template v-slot:prepend-item>
      <slot name="prepend-item">
        <v-col>Id</v-col>
        <v-col>Klient</v-col>
        <v-col>Obiekt</v-col>
        <v-col>Obis</v-col>
        <v-col>Lokalizacja</v-col>
      </slot>
    </template>
    <template v-slot:item="{ data }">
      <slot name="item" :data="data">
        <v-col>{{ data.item.id }}</v-col>
        <v-col>{{ data.item.customerName }}</v-col>
        <v-col>{{ data.item.facilityNumber }}</v-col>
        <v-col>{{ data.item.obis }}</v-col>
        <v-col>{{ data.item.meterLocation }}</v-col>
      </slot>
    </template>
  </abstract-autocomplete>
</template>

<script>
import { SensorApi } from '@/context/sensor/api/SensorApi';
import AbstractAutocomplete
  from '@/general/component/form/autocomplete/abstract/AbstractAutocomplete';
import AutocompleteProps from '@/general/component/form/autocomplete/abstract/AutocompleteProps';
import LocalValueInput from '@/general/component/form/autocomplete/abstract/LocalValueInput';

export default {
  components: { AbstractAutocomplete },
  mixins: [LocalValueInput, AutocompleteProps],
  props: {
    value: { type: [Number, Object, Array], default: null },
    queryParam: { type: String, default: "" },
    idPredicatePath: { type: String, default: "id" },
    itemValue: { type: String, default: "id" },
    preloadAllOptions: { type: Boolean, default: false },
    vid: { type: String, default: "sensor" },
    label: { type: String, default: "Sensor" },
    placeholder: { type: String, default: "Wybierz sensor" },
    selectedItemToText: { type: Function, default: item => item.id },
    listApi: { type: Function, default: SensorApi.findAutocomplete }
  }
};
</script>

<style scoped></style>
